<ng-template #headingContent>
  <span *ngIf="isDeparture" class="nordic-blue-900-text ms-medium-r upgrade-flight-departure">
    {{ 'departure' | finLocalization }}
  </span>
  <span *ngIf="isReturn" class="nordic-blue-900-text ms-medium-r upgrade-flight-return">
    {{ 'returnDate' | finLocalization }}
  </span>
  <span *ngIf="isMultiCity" class="nordic-blue-900-text ms-medium-r upgrade-flight-multicity">
    {{ 'oneUpgrade.flightNumber' | finLocalization: [flightNumber] }}
  </span>

  <span class="font-body-1 light-type" aria-hidden="true">{{
    bounds[0].segmentInfo.departureDateTime | finDateFormat: 'FULL'
  }}</span>
</ng-template>

<ng-container *ngIf="bounds.length as amount">
  <h2 *ngIf="headingLevel === 2" class="ms-xsmall-b flex flex--middle flex--space-between flex--wrap font-heading-4">
    <ng-container *ngTemplateOutlet="headingContent"></ng-container>
  </h2>
  <h3 *ngIf="headingLevel === 3" class="ms-xsmall-b flex flex--middle flex--space-between flex--wrap font-heading-4">
    <ng-container *ngTemplateOutlet="headingContent"></ng-container>
  </h3>

  <p class="mr-small-b">
    <span class="is-vishidden" *ngIf="(currentStage$ | async) === Stage.FLIGHTS">
      <ng-container *ngIf="amount > 1; else directFlightAriaText">
        {{
          'oneUpgrade.aria.journeyInfo'
            | finLocalization
              : {
                  departure: bounds[0].segmentInfo.boardPoint | finLocationName,
                  departureDate: bounds[0].segmentInfo.departureDateTime | finDateFormat: 'FULL',
                  departureTime: bounds[0].segmentInfo.departureDateTime | finTime,
                  arrival: bounds[amount - 1].segmentInfo.offPoint | finLocationName,
                  arrivalDate: bounds[amount - 1].segmentInfo.arrivalDateTime | finDateFormat: 'FULL',
                  arrivalTime: bounds[amount - 1].segmentInfo.arrivalDateTime | finTime,
                  stops: amount - 1,
                }
        }}
      </ng-container>

      <ng-template #directFlightAriaText>
        {{
          'oneUpgrade.aria.directJourneyInfo'
            | finLocalization
              : {
                  departure: bounds[0].segmentInfo.boardPoint | finLocationName,
                  departureDate: bounds[0].segmentInfo.departureDateTime | finDateFormat: 'FULL',
                  departureTime: bounds[0].segmentInfo.departureDateTime | finTime,
                  arrival: bounds[amount - 1].segmentInfo.offPoint | finLocationName,
                  arrivalDate: bounds[amount - 1].segmentInfo.arrivalDateTime | finDateFormat: 'FULL',
                  arrivalTime: bounds[amount - 1].segmentInfo.arrivalDateTime | finTime,
                }
        }}
      </ng-template>
    </span>

    <ng-container [ngSwitch]="amount - 1" *ngIf="(currentStage$ | async) === Stage.FLIGHTS">
      <span *ngSwitchCase="0" class="direct" aria-hidden="true">{{ 'oneUpgrade.direct' | finLocalization }}</span>
      <span *ngSwitchCase="1" class="stopover" aria-hidden="true">{{
        'stopOver' | finLocalization: [amount - 1]
      }}</span>
      <span *ngSwitchDefault class="stopovers" aria-hidden="true">{{
        'stopOvers' | finLocalization: [amount - 1]
      }}</span>
    </ng-container>
  </p>
</ng-container>
